import { css, type Theme } from "@emotion/react";

export const listItemStyles = (theme: Theme) => css`
  display: inline-flex;
  align-items: center;
  &:last-of-type {
    a {
      color: ${theme.text.emphasis};
      font-weight: 700;
    }
    svg {
      display: none;
    }
  }
`;
